var exports = {
  "container": "x127c5a35--14f714--container",
  "illustration": "x127c5a35--14f714--illustration",
  "illustration-empty": "x127c5a35--14f714--illustration-empty",
  "illustration-unauthorized": "x127c5a35--14f714--illustration-unauthorized",
  "text": "x127c5a35--14f714--text",
  "hint": "x127c5a35--14f714--hint",
  "icon": "x127c5a35--14f714--icon",
};

module.exports = exports;
